import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    chooseAnOther: {
        id: "inputSelectCard.chooseAnOther",
    },
    unknownComposer: {
        id: "unknownComposer",
    },
});

export default messages;
